<template>
  <div v-if="tenancy">
    <h4 v-if="tenancy.owner" class="text-success">{{tenancy.owner.name}}</h4><br />

    <div v-if="this.isSuper() && !isViewOnly()">
      <el-button icon="fa fa-trash-alt" aria-label="Delete tenancy"
       @click="deleteTenancy()" size="small" type="danger" circle>
     </el-button>

      </div>

    <br />

    <el-tabs type="border-card" v-model="currentTab">

      <el-tab-pane name="tenancy" label="Tenancy">
        <el-row :gutter="gr">
          <el-col :span="24">

          <div>

            <el-row :gutter="gr">
              <el-col :span="24">

                <el-card shadow="hover">

                  <el-col :span="18">
                    <el-row v-if="tenancy.landTitleRef" :gutter="gr">
                      <el-col :span="4">
                        <span class="text-muted">Land Tile Ref:</span>
                      </el-col>
                      <el-col :span="16">
                        <strong>{{tenancy.landTitleRef}}</strong>
                      </el-col>
                    </el-row>


                    <el-row>
                      <el-col :span="4">
                        <span class="text-muted">Tenancy Status</span>
                      </el-col>

                      <el-col :span="20">
                        <div v-if="renewal">
                          <b>{{tenancy.landStatus}}</b><i v-if="renewal.started">&nbsp; {{tenancy.landType === 'Rental' ? this.addSuffix(this.renewal.term, false) + ' Renewal' : tenancy.landType + 'd'}}: {{formatFriendlyDate(renewal.started)}}</i>
                        </div>
                        <div v-else>
                          <b>{{tenancy.landStatus}}</b><i v-if="tenancy.started">&nbsp; {{tenancy.landType === 'Rental' ? 'Rented' : tenancy.landType + 'd'}}: {{formatFriendlyDate(tenancy.started)}}</i>
                        </div>
                      </el-col>
                    </el-row>

                    <el-row v-if="tenancy.classificationType" :gutter="gr">
                      <el-col :span="4">
                        <span class="text-muted">Classification Type:</span>
                      </el-col>
                      <el-col :span="16">
                        <strong>{{tenancy.classificationType}}</strong>
                      </el-col>
                    </el-row>

                    <br />

                    <el-row>
                      <el-col :span="4">
                        <span class="text-muted">Tenancy Type</span>
                      </el-col>

                      <el-col :span="20">
                        <div v-if="renewal">
                          <b class="text-primary" v-if="tenancy.landType">{{tenancy.landType}} {{formatMoney(renewal.amount) + ' ' + (tenancy.frequency ? tenancy.frequency : '')}}</b>
                        </div>
                        <div v-else>
                          <b class="text-primary" v-if="tenancy.landType">{{tenancy.landType}} {{formatMoney(tenancy.landValue) + ' ' + (tenancy.frequency ? tenancy.frequency : '')}}</b>
                        </div>
                      </el-col>
                    </el-row>


                    <el-row v-if="tenancy.deposit">
                      <el-col :span="4">
                        <span class="text-muted">Deposit</span>
                      </el-col>

                      <el-col :span="20">
                        <span><b>{{formatMoney(tenancy.deposit)}}</b></span> <span v-if="tenancy.depositMonths"><i>&nbsp;(for {{plural('month', tenancy.depositMonths, true)}}<span v-if="tenancy.depositDate">&nbsp;on {{formatDate(tenancy.depositDate)}}</span>)</i></span>
                      </el-col>
                    </el-row>
                    <br />
                  </el-col>

                  <el-col :span="6"  align="right">
                    <el-col :span="24" align="right">

                      <div v-if="canAccess('property|finance')">

                        <tenancy-action
                          :site-data="site"
                          :tenancy-data="tenancy"
                          :contact-data="contact"
                          :read-only="readOnly"
                          @update="savedTenancy" />

                      </div>

                      <br />
                    </el-col>

                    <el-col
                        v-if="showRenewalButton && !isPurchase(tenancy) && canAccess('property')"
                        align="right"
                        :span="24">

                      <renewal-action
                        v-if="(tenancy.renewal || !renewed) && !isPurchase(tenancy)"
                        :tenancy-data="tenancy"
                        :site-data="site"
                        :disabled="!isManager() || readOnly || isViewOnly()"
                        @change="renewalChanged" />
                      <br />
                    </el-col>
                  </el-col>

                </el-card>

              </el-col>

            </el-row>

            <br />

            <el-row v-if="owner.name" :gutter="gr">
              <el-col :span="4">
                <span class="text-muted">Owner</span>
              </el-col>
              <el-col :span="20">
                <strong>{{owner.name}}</strong>
              </el-col>
            </el-row>

            <el-row  v-if="owner.address" :gutter="gr">
              <el-col :span="4">
                <span class="text-muted">Address</span>
              </el-col>
              <el-col :span="18">
                <strong>{{owner.address}}</strong>
              </el-col>
            </el-row>

            <el-row  v-if="owner.postCode" :gutter="gr">
              <el-col :span="4">
                <span class="text-muted">Post Code</span>
              </el-col>
              <el-col :span="20">
                <strong>{{owner.postCode}}</strong>
              </el-col>
            </el-row>

            <el-row  v-if="owner.phone" :gutter="gr">
              <el-col :span="4">
                <span class="text-muted">Phone</span>
              </el-col>
              <el-col :span="20">
                <strong>{{owner.phone}}</strong>
              </el-col>
            </el-row>

            <el-row  v-if="owner.email" :gutter="gr">
              <el-col :span="4">
                <span class="text-muted">e-Mail</span>
              </el-col>
              <el-col :span="20">
                <strong><a :href="'mailto:' + owner.email + '?subject=RE: Tower Site ' + site.siteName + ' (' + site.siteId + ')'">{{owner.email}}</a></strong>
              </el-col>
            </el-row>


            <el-row  v-if="owner && owner.beneficiaryName1 && canAccess('finance')" :gutter="11">
              <br />
              <el-col :span="4">
                <span class="text-muted">Bank</span>
              </el-col>
              <el-col :span="20">
                <i v-if="owner.beneficiaryName1">{{owner.beneficiaryName1}}&nbsp;
                </i><strong>{{owner.bankName1}}</strong>
                &nbsp;&nbsp;<span v-show="owner.bankAccount1">a/c: <strong>{{owner.bankAccount1}}</strong></span>
              </el-col>

              <el-col :span="20" :offset="4">
                <i v-if="owner.beneficiaryName2">{{owner.beneficiaryName2}}&nbsp;
                </i><strong>{{owner.bankName2}}</strong>
                &nbsp;&nbsp;<span v-show="owner.bankAccount2">a/c: <strong>{{owner.bankAccount2}}</strong></span>
              </el-col>

              <el-col :span="20" :offset="4">
                <i v-if="owner.beneficiaryName3">{{owner.beneficiaryName3}}&nbsp;
                </i><strong>{{owner.bankName3}}</strong>
                &nbsp;&nbsp;<span v-show="owner.bankAccount3">a/c: <strong>{{owner.bankAccount3}}</strong></span>
              </el-col>
            </el-row>
          </div>

        <!-- Landowner not found --
        <div v-else>
          <el-row>
            <el-col :span="20">
              <span class="text-muted">No Landlord selected</span>
            </el-col>
            <el-col :span="4">
              <br />
            </el-col>
          </el-row>
        </div>
-->

        <!-- Owner's rep. -->
          <el-row v-if="owner && contact && contact.name">
            <br />
            <el-col :span="4">
              <span class="text-muted">Owner's Rep.</span>
            </el-col>
            <el-col v-if="contact" :span="20">
              <span v-if="contact.name">&nbsp;<b>{{contact.name}}</b>
                <span v-if="contact.phone">
                  &nbsp;<i class="fa fa-phone">&nbsp;</i><a :href="'tel:' + contact.phone">{{contact.phone}}</a></span>
                  <span v-if="contact.email">
                    &nbsp;<i class="fa fa-envelope">&nbsp;</i>
                    <a :href="'mailto:'+ contact.email + '?subject=RE: Tower Site ' + site.siteName + ' (' + site.siteId + ')'">{{contact.email}}</a>
                  </span>
                </span>
              </el-col>
            </el-row>

        </el-col>

        <el-col v-if="!isPurchase(tenancy) && owner && showAgreement && (canAccess('property|finance') || isLandlordCo())" :span="24">

          <br />

          <xolas-table
            table-ref="renewalTable"
            :title="tenancy.landType + ' Renewals'"
            :url="'/tenancy/renewals/' + tenancy.id"
            :show-search="false"
            :fields="fields">

            <template #delete="props">
              <el-button v-if="isManager('property|finance')" type="danger" circle icon="fa fa-trash" size="mini" aria-label="Delete renewal" @click="deleteRenewal(props.rowData)" :disabled="readOnly || isViewOnly()" />
            </template>

          </xolas-table>

        </el-col>


<!--
        <el-col v-if="!isPurchase(tenancy) && owner && showAgreement && canAccess('property|finance')" :span="24">
          <br />
          <h3>{{tenancy.landType}} Renewals</h3>
          <el-table
             ref="renewalTable"
             :data="tenancy.renewals"
             stripe
             height="300"
             style="width: 100%">

             <el-table-column
               prop="term"
               label="Term"
               :formatter="formatTerm">
             </el-table-column>

             <el-table-column
               prop="started"
               label="Started">
               <template #default="scope">
                  <date-input v-model="scope.row.started" size="mini" :disabled="!(!scope.row.saved && !scope.row.started)" no-form />
              </template>
             </el-table-column>

             <el-table-column
               prop="expiry"
               label="Expiry">
               <template #default="scope">
                  <date-input v-model="scope.row.expiry" size="mini" :disabled="!(!scope.row.saved && !scope.row.expiry)" no-form />
              </template>
             </el-table-column>
             <el-table-column
               prop="amount"
               label="Amount">
               <template #default="scope">
                  <float-input v-model="scope.row.amount" size="mini" :disabled="!(!scope.row.saved && !scope.row.amount)" no-form />
              </template>
             </el-table-column>

             <el-table-column
                v-if="showTax()"
               prop="tax"
               :formatter="formatAmount"
               label="Tax" />

               <el-table-column
                  v-if="showTax()"
                 prop="total"
                 :formatter="formatAmount"
                 label="Total" />

             <el-table-column align="right">
               <template #default="scope">
                 <el-button
                   v-if="isManager() && !scope.row.saved"
                   type="success"
                   size="small"
                   icon="fa fa-check"
                   @click="saveRow(scope.row)">
                   Save
                 </el-button>
               </template>
             </el-table-column>
           </el-table>
         </el-col>
-->
        </el-row>

        <br />

        <files-panel title="Tenancy Attachments" type="site" :id="tenancy.site_id" process="tenancy" :process-id="tenancy.id"  :max-files="5" :disabled="!isManager('property|management') || isViewOnly()" />

        <el-row v-if="tenancy.remarks">
          <el-col :span="24">
            <h6>Remarks</h6>
            <div class="html-remarks">
              <span v-safe-html="tenancy.remarks" />
            </div>
          </el-col>
        </el-row>



        <div v-if="tenancy.updated_at">
          <hr />
          <span v-if="isManager('property') && !hideDelete && !isViewOnly()">
            <el-button type="danger" circle size="small" aria-label="Delete tenancy" @click="deleteTenancy"><i class="fa fa-trash"></i></el-button>
          </span>
          <span class="pull-right">Last update: <b>{{formatFriendlyDate(tenancy.updated_at)}}</b><span v-if="tenancy.updated_by"> by {{tenancy.updated_by}}</span></span>
        </div>

        </el-tab-pane>



        <el-tab-pane v-if="owner && (canAccess('finance|property') || isLandlordCo())" name="statement" label="Statement">
          <site-finance-tenancy :row-data="rowData" :read-only="readOnly" />
        </el-tab-pane>


        <el-tab-pane v-if="tenancy.utilAccount || tenancy.utilAddress || tenancy.utilDeposit || tenancy.utilDepositDate" name="utility" :label="this.utilLabel + ' Details'">

          <h4>{{utilLabel}} Details</h4>
          <el-row v-if="tenancy.util && tenancy.util.name" :gutter="gr">
            <el-col :span="4">
              <span class="text-muted">Utilities Provider</span>
            </el-col>
            <el-col :span="20">
              <strong>{{tenancy.util.name}}</strong>&nbsp;[{{tenancy.util.shortName}}]
            </el-col>
          </el-row>

          <el-row v-if="tenancy.utilAccount" :gutter="gr">
            <el-col :span="4">
              <span class="text-muted">{{utilLabel}} Acc. #</span>
            </el-col>
            <el-col :span="20">
              <strong>{{tenancy.utilAccount}}</strong>
            </el-col>
          </el-row>

          <el-row  v-if="tenancy.utilAddress" :gutter="gr">
            <el-col :span="4">
              <span class="text-muted">Address</span>
            </el-col>
            <el-col :span="20">
              <strong>{{tenancy.utilAddress}}</strong>
            </el-col>
          </el-row>

          <el-row  v-if="tenancy.utilDeposit" :gutter="gr">
            <el-col :span="4">
              <span class="text-muted">Deposit</span>
            </el-col>
            <el-col :span="20">
              <strong>{{formatMoney(tenancy.utilDeposit)}}</strong>
            </el-col>
          </el-row>

          <el-row  v-if="tenancy.utilDepositDate" :gutter="gr">
            <el-col :span="4">
              <span class="text-muted">Deposit Date</span>
            </el-col>
            <el-col :span="20">
              <strong>{{formatDate(tenancy.utilDepositDate)}}</strong>
            </el-col>
          </el-row>

        </el-tab-pane>


      </el-tabs>

    </div>

  </template>



  <script>

  import {settings} from '@/components/Data'

  import ArrayMixins from '@/mixins/ArrayMixins'
  import TenancyMixins from '@/mixins/TenancyMixins'
  import SiteMixins from '@/mixins/SiteMixins'

  import TenancyAction from '@/components/actions/TenancyAction'
  import RenewalAction from '@/components/actions/RenewalAction'

  import FilesPanel from '@/components/atoms/files/FilesPanel'

  import SiteFinanceTenancy from '@/components/sites/finance/tenancy/SiteFinanceTenancy'

  export default {

    mixins: [ArrayMixins, TenancyMixins, SiteMixins],

    components: {
      FilesPanel,
      RenewalAction,
      SiteFinanceTenancy,
      TenancyAction
    },

    props: {

      rowData: {
        type: Object,
        required: true
      },

      tenancyData: {
        type: Object,
        required: true
      },

      index: {
        type: Number,
        required: true
      },

      showAgreement: {
        type: Boolean,
        default: true
      },

      showRenewalButton: {
        type: Boolean,
        default: true
      },

      editable: {
        type: Boolean,
        default: false
      },

      hideDelete: {
        type: Boolean,
        default: false
      },

      readOnly: {
        type: Boolean,
        default: false
      }

    },



    methods: {

      formatTerm (row, col, value, index) {
        return this.addSuffix(value, false)
      },


      formatColDate (row, col, value, index) {
        return this.formatDate(value)
      },


      formatAmount (row, col, value, index) {
        return this.formatMoney(value)
      },


      checkSaved () {

        if (this.tenancy && this.tenancy.renewals) {

          for (var i = 0; i < this.tenancy.renewals.length; i++) {

            let t = this.tenancy.renewals[i]
            this.tenancy.renewals[i].saved = !(!t.started || !t.expiry || !t.amount)

          } // for

        }
      },


      savedTenancy (data, adding = false) {

        if (!data.owner) {
          data.owner = this.tenancy.owner
        }

        if (!data.site) {
          data.site = this.tenancy.site
        }

        this.tenancy = data
        this.owner = data.owner
        this.checkSaved()

        this.$emit('update', this.tenancy, adding)
      },



      deleteSuccess (data) {
        this.$emit('deleted', this.index, this.tenancy.id)
        this.tenancy = null
      },



      deleteTenancy () {
        this.deleteItem(this, this.tenancy.id, '/tenancy', 'Tenancy for ' + this.owner.name + ', and all renewal records.', this.deleteSuccess)
      },



      deleteRenewal (row) {
        this.deleteItem(this, row.id, '/tenancy/renewal', this.addSuffix(row.term) + 'Renewal [' + row.id + ']', null, true, 'renewalTable')
      },


      renewalChanged (ren) {

        if (this.tenancy) {
          this.tenancy.renewal = ren
        }

//        this.$refs.renewalTable.refresh()
      }

/*
      savedRowSuccess (data) {
        let i = this.findIndex('id', data.id, this.tenancy.renewals)

        if (i) {
          data.saved = true
          this.tenancy.renewals[i] = data
        }
      },


      saveRow (renewal) {

        if (renewal && renewal.id) {

          renewal = this.renewalCalc(renewal, renewal.amount, renewal.increment, renewal.taxable)
          this.saveForm(this, '/tenancy/renewal', renewal.id, renewal, 'Renewal', this.savedRowSuccess)

        } else {

          this.$message({message: 'Invalid renwal data, can\'t save.', type: 'warning'})

        }
      },

*/
    },



    watch: {

      tenancy: function (data) {
        if (data) {
          this.tenancy = data

          if (data.contact) {
            this.contact = data.contact
          }
        }
      }

    },



    data () {

      return {
        gr: 7,
        renewed: false,
        currentTab: 'tenancy',
        utilLabel: (this.tenancyData.util && this.tenancyData.util.shortName ? this.tenancyData.util.shortName : 'Util.'),
        site: this.rowData,
        tenancy: this.tenancyData ? this.tenancyData : this.getTableStruct('tenancy'),
        renewal: this.tenancyData && this.tenancyData.renewal ? this.tenancyData.renewal : null,
        owner: this.tenancyData && this.tenancyData.owner ? this.tenancyData.owner : this.getTableStruct('organisation'),
        contact: this.tenancyData && this.tenancyData.contact ? this.tenancyData.contact : this.getTableStruct('contacts'),
        fields: [
          {
            name: 'term',
            title: 'Term',
            callback: this.addSuffix,
            titleClass: 'hidden-md-and-down',
            dataClass: 'hidden-md-and-down'
          },
          {
            name: 'started',
            title: 'Started',
            callback: this.formatDate
          },
          {
            name: 'expiry',
            title: 'Expiry',
            callback: this.formatDate
          },
          {
            name: 'increment',
            title: 'Incr.',
            callback: this.formatPercent,
            titleClass: 'hidden-sm-and-down',
            dataClass: 'hidden-sm-and-down'
          },
        {
            name: 'amount',
            title: 'Amount',
            callback: this.formatMoney,
            titleClass: 'hidden-sm-and-down',
            dataClass: 'hidden-sm-and-down'
          },
          {
            name: 'tax',
            title: settings.taxLabel,
            callback: this.formatMoney,
            visible: this.showTax(),
            titleClass: 'hidden-sm-and-down',
            dataClass: 'hidden-sm-and-down'
          },
          {
            name: 'total',
            title: 'TOTAL',
            callback: this.formatMoney,
            visible: this.showTax()
          },
          {
            name: '__slot:delete'
          }
        ]
      }
    },

    created () {
      this.checkSaved()
    }

  }

  </script>

<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; line-height: 1.25; }
</style>
